// Document ready
$(function(){

	// console.log('nav-primary');

		var NAV = {
			nav: $("#nav-primary"),
			toggleEls: $(".overlay-nav-toggle"),
			subNavToggleButtons: $(".secondary-list-toggle"),
			closeButton: $("#close-nav"),
			isOpen: false,
			init: function() {
				var that = this;
				this.defaultNavHeight = $(this.nav).outerHeight();
				this.calcHeight();
				$(this.nav).addClass("js-loaded").css({"top": -this.navHeight});
				this.closeSubLists();
				this.removeEmptyEls();
				this.addActiveClass();

				$(this.toggleEls).on("click", function() {
					that.toggleElClicked = this;
					that.toggleNav();
				});

				$(window).resize(function() {
					that.isOpen = false;
					that.calcHeight();
				});
			},
			calcHeight: function() {
				var bodyHeight = $("body").outerHeight();

				if(bodyHeight > this.defaultNavHeight) {
					this.navHeight = bodyHeight;
				} else {
					this.navHeight = this.defaultNavHeight;
				}
				$(this.nav).css({
					"top": -this.navHeight,
					"height": this.navHeight
				});
			},
			toggleNav: function() {
				var that = this;

				if(this.isOpen === false) {

					$(this.nav).css({"opacity": 0, "top": 0});
					setTimeout(function() {
						$(that.nav).animate({"opacity": 1}, 300);
					}, 0);
					this.isOpen = true;

				} else if (this.isOpen === true) {

					$(this.nav).animate({"opacity": 0}, 300);
					setTimeout(function() {
						$(that.nav).css({"top": -that.navHeight});
					}, 300);

					this.isOpen = false;
				}
			},
			closeSubLists: function() {
				var that = this;

				// When a new list is opened, sibling lists are closed
				$(this.subNavToggleButtons).each(function() {
					$(this).on("click", function() {
						$(this).closest('li').siblings().each(function() {
	            var $ul = $(this).find('ul');

	            if ($ul.hasClass('in')) {
	              $ul.collapse('hide');
	            }
	          });
					});
				});

				// when close button is hit, all lists close
				$(this.closeButton).on("click", function() {
					var uls = $(that.nav).find("ul")
					$(uls).each(function() {
						if($(this).hasClass("in")) {
							$(this).collapse("hide");
							$(this).closest("li").find(".secondary-list-toggle").addClass("collapsed");
						}
					});
				});
			},
			addActiveClass: function() {
				$(this.subNavToggleButtons).each(function() {
					$(this).on("click", function() {
						var buttonClicked = this;
						if($(this).hasClass("active")) {
							$(this).removeClass("active");
						}
						// remove active class on any other texts next to any other dropdown icons
						$(this).closest("ul").find(".active").removeClass("active");
						$(this).closest("ul").find(".secondary-list-toggle").each(function() {
							if( this !== buttonClicked ) {
								$(this).addClass("collapsed");
							}
						});

						// toggles active class on text next to dropdown icon
						$(this).closest("li").find(".link").toggleClass("active");
					})
				});
			},
			removeEmptyEls: function() {
				var lis = $(this.nav).find("li");

				$(lis).each(function() {
					function isEmpty( el ){
				      return !$.trim(el.html())
				  }
				  if (isEmpty($(this))) {
			      $(this).remove();
				  }
				});
			}
		};
		NAV.init();
});
